class AppLogger {
    error(message: any, ...optionalParams: any[]): void {
        console.error(
            '%c🔵 Error ',
            'background: #2196F3; color: white; font-weight: bold; padding: 2px 6px; border-radius: 3px; margin-right: 8px;',
            message,
            ...optionalParams
        );
    }
}

export const Logger = new AppLogger();
